import { useMemo } from "preact/hooks";

export const MeowCollectionItem = ({ collectionThumbnail , attributes = {}, setIsLoadingRoot, index, isOdd, isLast }) => {
  const { name: galleryName, description: galleryDescription, gallery_id, wplr_collection_id, media_id, img_src, img_srcset, classNames = [] } = collectionThumbnail;

  const oddAndLast = isOdd && isLast;
  let className = ['mgl-collection-item', ...classNames].join(' ').trim();

  /**
   *  index 1 { grid-area: 1 / 1 / 4 / 3; }
      index 2 { grid-area: 1 / 3 / 4 / 6; }

      index 3 { grid-area: 4 / 1 / 7 / 4; }
      index 4 { grid-area: 4 / 4 / 7 / 6; }
      
      repeat...
   */

  const imgHTML = useMemo(() => {
    return `<img class="mgl-collection-thumbnail no-lightbox" src="${img_src}" srcset="${img_srcset}" />`;
  }, [img_src, img_srcset]);

  const gridAreaStyle = useMemo(() => {
    if (index === undefined) return {};
    
    // Handle the case where there's an odd number of items and this is the last one
    if (oddAndLast) {
      // Convert to 0-based index for calculations
      const zeroBasedIndex = index - 1;
      
      // Calculate which "group" of 4 we're in (0, 1, 2, ...)
      const groupIndex = Math.floor(zeroBasedIndex / 4);
      
      // Calculate position within the group (0, 1, 2, 3)
      const positionInGroup = zeroBasedIndex % 4;
      
      // Base row for this group (each group adds 6 rows: 3 for first row + 3 for second row)
      const baseRow = groupIndex * 6 + 1;
      
      let gridArea;
      if (positionInGroup === 0) {
        // If it's the first position in a group and the last item, span the full width
        gridArea = `${baseRow} / 1 / ${baseRow + 3} / 6`;
      } else if (positionInGroup === 2) {
        // If it's the third position in a group and the last item, span the full width
        gridArea = `${baseRow + 3} / 1 / ${baseRow + 6} / 6`;
      } else {
        // For other positions (1 or 3), use normal positioning
        // This shouldn't happen in a typical odd scenario, but fallback to normal positioning
        return { gridArea: positionInGroup === 1 ? `${baseRow} / 3 / ${baseRow + 3} / 6` : `${baseRow + 3} / 4 / ${baseRow + 6} / 6` };
      }
      
      return { gridArea };
    }
    
    // Convert to 0-based index for calculations
    const zeroBasedIndex = index - 1;
    
    // Calculate which "group" of 4 we're in (0, 1, 2, ...)
    const groupIndex = Math.floor(zeroBasedIndex / 4);
    
    // Calculate position within the group (0, 1, 2, 3)
    const positionInGroup = zeroBasedIndex % 4;
    
    // Base row for this group (each group adds 6 rows: 3 for first row + 3 for second row)
    const baseRow = groupIndex * 6 + 1;
    
    let gridArea;
    switch (positionInGroup) {
      case 0: // First item in group (top-left)
        gridArea = `${baseRow} / 1 / ${baseRow + 3} / 3`;
        break;
      case 1: // Second item in group (top-right)
        gridArea = `${baseRow} / 3 / ${baseRow + 3} / 6`;
        break;
      case 2: // Third item in group (bottom-left)
        gridArea = `${baseRow + 3} / 1 / ${baseRow + 6} / 4`;
        break;
      case 3: // Fourth item in group (bottom-right)
        gridArea = `${baseRow + 3} / 4 / ${baseRow + 6} / 6`;
        break;
    }
    
    return { gridArea };
  }, [index, oddAndLast]);

  const onClickGalleryItem = () => {
    let id, search_slug;

    if (wplr_collection_id !== undefined) {
      id = wplr_collection_id;
      search_slug = 'wplr_collection_id';
    } else {
      id = gallery_id;
      search_slug = 'gallery_id';
    }

    const url = new URL(window.location.href);
    url.searchParams.set(search_slug, id);
    window.history.pushState({}, '', url);

    setIsLoadingRoot(id, search_slug);
  }

  return (
    <figure className={className} {...attributes} onClick={() => onClickGalleryItem()} style={gridAreaStyle}>
        <div className="mgl-collection-img-container" >
          <div
            className="mgl-collection-image-content"
            dangerouslySetInnerHTML={{ __html: imgHTML }}
          />
          <div className="mgl-collection-overlay"></div>
          <div className="mgl-collection-info">
            <h3 className="mgl-collection-title">{galleryName}</h3>
            <p className="mgl-collection-caption">{galleryDescription}</p>
          </div>
      </div>
    </figure>
  );
};